const LoadingState = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin w-12 h-12 border-4 border-teal-600 border-t-transparent rounded-full mx-auto mb-4"></div>
      <p className="text-gray-600">Loading your itinerary...</p>
    </div>
  </div>
);

export default LoadingState;
